import { axios } from '@Root/API'

export const getFinanceTuitionStaticOptions = () => {
	return axios.get('get-data-finances')
}
